import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { IframeData } from '../../../shared/public-api';

@Component({
  selector: 'admin-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss'],
  imports: [CommonModule],
})
export class IframeComponent extends BaseComponent<IframeData> implements OnInit {
  url: SafeResourceUrl;
  width = '';
  height = '';

  constructor(private domSanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    this.width = this.data.width;
    this.height = this.data.height;
    this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(this.data.url);
  }
}
